import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppLinkService {
  readonly playStoreUrl =
    'https://play.google.com/store/apps/details?id=arnoarobase.cuisineafricaine';

  isAndroidDevice(): boolean {
    return typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent);
  }

  buildRecipeAppLink(recipeId: number): string {
    return `${this.getBaseOrigin()}/open-app/recipe/${recipeId}`;
  }

  buildProfileAppLink(memberId: number): string {
    return `${this.getBaseOrigin()}/open-app/profile/${memberId}`;
  }

  buildAuthAppLink(source: 'password-reset' | 'email-verification'): string {
    return `${this.getBaseOrigin()}/open-app/auth?source=${encodeURIComponent(source)}`;
  }

  private getBaseOrigin(): string {
    if (typeof window === 'undefined') return 'https://afrotchop.afrimoov.com';
    if (window.location.hostname === 'dev.afrifood.fr') return 'https://afrotchop-dev.afrimoov.com';
    if (['afrifood.fr', 'www.afrifood.fr'].includes(window.location.hostname)) {
      return 'https://afrotchop.afrimoov.com';
    }
    return window.location.origin;
  }
}
